var oe = Object.defineProperty, re = Object.defineProperties;
var le = Object.getOwnPropertyDescriptors;
var B = Object.getOwnPropertySymbols;
var ne = Object.prototype.hasOwnProperty, se = Object.prototype.propertyIsEnumerable;
var E = (u, n, r) => n in u ? oe(u, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : u[n] = r, N = (u, n) => {
  for (var r in n || (n = {}))
    ne.call(n, r) && E(u, r, n[r]);
  if (B)
    for (var r of B(n))
      se.call(n, r) && E(u, r, n[r]);
  return u;
}, T = (u, n) => re(u, le(n));
var v = (u, n, r) => new Promise((k, x) => {
  var C = (s) => {
    try {
      g(r.next(s));
    } catch (l) {
      x(l);
    }
  }, c = (s) => {
    try {
      g(r.throw(s));
    } catch (l) {
      x(l);
    }
  }, g = (s) => s.done ? k(s.value) : Promise.resolve(s.value).then(C, c);
  g((r = r.apply(u, n)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postCreateAiUrgentConfirm as ie } from "../../request/designordercenter/productionOrder/aiOperation/createAiUrgentConfirm/post.js";
import { postCreateAiUrgent as de } from "../../request/designordercenter/productionOrder/aiOperation/createAiUrgent/post.js";
import ue from "./aiUrgentFailDialog.vue.js";
import { postSpecialApplyCreate as fe } from "../../request/designordercenter/productionOrder/specialApply/create/post.js";
import { getDict as V } from "@oppein/op-utils";
import ce from "../../assets/lightning.png.js";
import { defineComponent as pe, useTemplateRef as W, onMounted as ge, openBlock as me, createElementBlock as ye, createElementVNode as b, createVNode as d, withCtx as f, createTextVNode as _, Fragment as be, h as M } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as ve } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as m, unref as i, isRef as xe } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import j from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import L from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import he from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/image/src/Image.js";
import _e from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tag/src/Tag.js";
import { toDisplayString as P } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import ke from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import S from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import Y from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const we = { style: { display: "inline-block", "background-color": "#3370ff", width: "30px", height: "30px", "border-radius": "15px", "text-align": "center", "line-height": "35px" } }, Ce = { style: { "font-size": "14px", "margin-bottom": "10px" } }, De = { style: { "text-align": "center", "margin-bottom": "25px" } }, Ne = { style: { width: "100%", display: "flex", "justify-content": "right" } }, Me = { style: { width: "100%", display: "flex", "justify-content": "center" } }, qe = /* @__PURE__ */ pe({
  __name: "aiUrgentDialog.ce",
  emits: ["submit"],
  setup(u, { expose: n, emit: r }) {
    const k = W("aiUrgentDialogContainer"), x = ve(), C = W("aiUrgentFailDialogRef"), c = m(!1), g = m(""), s = m([]), l = m(!1), U = m([]), I = m([]);
    function $() {
      Q({ orderId: w.value.orderId || "" });
    }
    const q = () => v(this, null, function* () {
      const [e, t] = yield Promise.all([V("ROOT_brand"), V("ROOT_category")]);
      U.value = e, I.value = t;
    }), G = [
      {
        title: "合同自编号",
        key: "productionOrderContractNo"
      },
      {
        title: "品牌",
        key: "brand",
        render: (e) => M(
          "span",
          {
            style: {
              fontSize: "14px",
              fontWeight: "400",
              color: "rgba(100, 106, 115, 1)"
            }
          },
          { default: () => e.brand }
        )
      },
      {
        title: "品类",
        key: "category",
        render: (e) => M(
          "span",
          {
            style: {
              fontSize: "14px",
              fontWeight: "400",
              color: "rgba(100, 106, 115, 1)"
            }
          },
          { default: () => e.category }
        )
      },
      {
        title: "订单状态",
        key: "statusName",
        render: (e) => M(
          "div",
          {
            style: N({
              color: "#fff",
              background: "red",
              padding: "2px 7px",
              textAlign: "center",
              fontSize: "12px",
              fontWeight: "400",
              display: "inline-block"
            }, J(e.status || ""))
          },
          { default: () => e.statusName || "" }
        )
      },
      {
        title: "工厂计划交期",
        key: "planDeliveryDt",
        render: (e) => M(
          "span",
          {
            style: {
              fontSize: "14px",
              fontWeight: "400",
              color: "rgba(100, 106, 115, 1)"
            }
          },
          { default: () => e.planDeliveryDt ? Z(e.planDeliveryDt) : "" }
        )
      }
    ], J = (e) => ({
      "-1": { background: "rgba(255, 240, 239, 1)", color: "rgba(227, 73, 39, 1)" },
      1022: { background: "rgba(255, 240, 239, 1)", color: "rgba(227, 73, 39, 1)" },
      1015: { background: "rgba(255, 240, 239, 1)", color: "rgba(227, 73, 39, 1)" },
      1012: { background: "rgba(255, 245, 234, 1)", color: "rgba(255, 130, 3, 1)" }
    })[e] || {
      background: "rgba(52, 199, 36, 0.2)",
      color: "rgba(35, 123, 25, 1)"
    }, K = () => v(this, null, function* () {
      c.value = !1, H("submit");
    }), Q = (e) => v(this, null, function* () {
      try {
        l.value = !0;
        const t = x.loading("正在提交申请，请稍候...", {
          duration: 0,
          closable: !0
        }), a = yield fe({
          orderId: e.orderId,
          specialApplyType: "express_bpm_process",
          isAutomatic: 1
        });
        t.destroy(), l.value = !1, a && a.status && (x.success("订单加急申请已提交，请等待审批", {
          duration: 3e3,
          closable: !0
        }), y.value = !1, l.value = !1);
      } catch (t) {
        l.value = !1, console.error("请求失败:", t);
      }
    }), z = m([]), X = () => v(this, null, function* () {
      var e, t, a, p;
      try {
        l.value = !0;
        const o = yield ie(T(N({}, w.value), {
          authenticationCode: g.value || ""
        }));
        o && o.status ? ((e = o == null ? void 0 : o.data) != null && e.Success ? (x.success("当前列表所有订单加急成功"), c.value = !1) : (z.value = ((t = o == null ? void 0 : o.data) == null ? void 0 : t.Orders) || [], (p = C.value) == null || p.open(z.value, ((a = o == null ? void 0 : o.data) == null ? void 0 : a.Msg) || "")), l.value = !1) : (l.value = !1, c.value = !1);
      } catch (o) {
        l.value = !1, console.error("请求失败:", o), s.value = [], g.value = "";
      }
    }), w = m({
      orderId: ""
    });
    ge(() => v(this, null, function* () {
      yield q();
    }));
    function Z(e, t = "yyyy-MM-dd HH:mm:ss") {
      const a = typeof e == "string" || typeof e == "number" ? new Date(e) : e;
      if (isNaN(a.getTime()))
        return "";
      const p = (h) => h.toString().padStart(2, "0"), o = {
        yyyy: a.getFullYear().toString(),
        MM: p(a.getMonth() + 1),
        dd: p(a.getDate()),
        HH: p(a.getHours()),
        mm: p(a.getMinutes()),
        ss: p(a.getSeconds())
      };
      return t.replace(/yyyy|MM|dd|HH|mm|ss/g, (h) => o[h] || "");
    }
    const ee = () => v(this, null, function* () {
      try {
        l.value = !0;
        const e = yield de(w.value);
        e && e.data && e.status ? (l.value = !1, s.value = e.data.orderList || [], g.value = e.data.authenticationCode || "", s.value = s.value.map((t) => {
          var a, p, o, h;
          return T(N({}, t), {
            brand: ((p = (a = U.value) == null ? void 0 : a.find((O) => O.value === t.brand)) == null ? void 0 : p.label) || t.brand,
            category: ((h = (o = I.value) == null ? void 0 : o.find((O) => O.value === t.category)) == null ? void 0 : h.label) || t.category
          });
        }), c.value = !0) : (console.warn("获取数据失败：response 或 data 为空"), s.value = [], g.value = "", ae((e == null ? void 0 : e.message) || "获取数据失败"));
      } catch (e) {
        l.value = !1, console.error("请求失败:", e), s.value = [], g.value = "";
      }
    });
    let y = m(!1), A = "", D = null;
    function te(e) {
      w.value.orderId = e.orderId || "", e.notAi ? (A = `订单合同自编号为${e.productionOrderContractNo || ""} 订单要加急此订单吗？`, y.value = !0) : ee();
    }
    const F = () => {
      c.value = !1, y.value = !1, D = null, w.value = {
        orderId: ""
      };
    }, ae = (e) => {
      console.log("submit", e), c.value = !1, H("submit", e);
    }, H = r, R = () => {
      c.value = !1, y.value = !1, D && (D([]), D = null);
    };
    return n({ open: te }), (e, t) => (me(), ye(be, null, [
      b("div", {
        ref_key: "aiUrgentDialogContainer",
        ref: k
      }, null, 512),
      d(ue, {
        ref_key: "aiUrgentFailDialogRef",
        ref: C,
        onSubmit: K
      }, null, 512),
      d(i(Y), {
        bordered: "",
        show: c.value,
        "onUpdate:show": t[0] || (t[0] = (a) => c.value = a),
        "mask-closable": !1,
        "z-index": 9999,
        to: k.value || "body"
      }, {
        default: f(() => [
          d(i(j), { show: l.value }, {
            default: f(() => [
              d(i(L), {
                style: { width: "774px" },
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: F
              }, {
                header: f(() => [
                  b("span", we, [
                    d(i(he), {
                      width: "14px",
                      height: "21px",
                      src: i(ce)
                    }, null, 8, ["src"])
                  ]),
                  t[2] || (t[2] = b("span", { style: { "margin-left": "15px", "font-size": "20px", "font-weight": "600" } }, "订单加急", -1))
                ]),
                default: f(() => [
                  b("div", Ce, [
                    b("div", De, [
                      d(i(_e), {
                        type: "warning",
                        style: { width: "100%", height: "36px", "line-height": "36px", "text-align": "center", display: "inline-block", color: "rgba(31, 35, 41, 1)", "font-size": "14px", "font-weight": "400" }
                      }, {
                        default: f(() => [
                          t[3] || (t[3] = b("span", { style: { display: "inline-block", "background-color": "rgba(255, 136, 0, 1)", width: "16px", height: "16px", "border-radius": "8px", "text-align": "center", "line-height": "16px", color: "#fff", "margin-right": "10px" } }, "!", -1)),
                          _("同客户齐套批次号共" + P(s.value.length) + "个工厂订单，需整批发起加急！ ", 1)
                        ]),
                        _: 1,
                        __: [3]
                      })
                    ])
                  ]),
                  d(i(ke), {
                    columns: G,
                    data: s.value,
                    bordered: !1
                  }, null, 8, ["data"]),
                  b("div", Ne, [
                    d(i(S), {
                      onClick: R,
                      style: { "margin-top": "22px", "border-radius": "5px" }
                    }, {
                      default: f(() => t[4] || (t[4] = [
                        _("取消", -1)
                      ])),
                      _: 1,
                      __: [4]
                    }),
                    d(i(S), {
                      onClick: X,
                      style: { "margin-left": "30px", "margin-top": "22px", "background-color": "#3370ff !important", "border-color": "#3370ff !important", "--n-border": "1px solid #3370ff", "--n-button-color": "#fff !important", "border-radius": "5px" },
                      type: "primary"
                    }, {
                      default: f(() => t[5] || (t[5] = [
                        _("确认", -1)
                      ])),
                      _: 1,
                      __: [5]
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"]),
      d(i(Y), {
        bordered: "",
        show: i(y),
        "onUpdate:show": t[1] || (t[1] = (a) => xe(y) ? y.value = a : y = a),
        "mask-closable": !1,
        "z-index": 9999,
        to: k.value || "body"
      }, {
        default: f(() => [
          d(i(j), { show: l.value }, {
            default: f(() => [
              d(i(L), {
                style: { width: "800px" },
                title: "订单加急",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: F
              }, {
                default: f(() => [
                  _(P(i(A)) + " ", 1),
                  b("div", Me, [
                    d(i(S), {
                      onClick: R,
                      style: { "margin-top": "22px" }
                    }, {
                      default: f(() => t[6] || (t[6] = [
                        _("取消", -1)
                      ])),
                      _: 1,
                      __: [6]
                    }),
                    d(i(S), {
                      onClick: $,
                      style: { "margin-left": "30px", "margin-top": "22px", "background-color": "#1890ff !important", "border-color": "#1890ff !important", "--n-border": "1px solid #1890ff", "--n-button-color": "#fff !important" },
                      type: "primary"
                    }, {
                      default: f(() => t[7] || (t[7] = [
                        _("确认", -1)
                      ])),
                      _: 1,
                      __: [7]
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  qe as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-urgent-dialog/aiUrgentDialog.ce.vue.js
// module id = 1209
// module chunks = 67